import { useDispatch, useSelector } from 'react-redux';
import I18n from '../../../config/i18n';
import { loadNextPageOfReviews } from '../actions';
import type { RootState } from '../../../config/redux/types';

import './LoadMoreReviewsButton.css';

export default function LoadMoreReviewsButton(): JSX.Element | null {
  const accommodationReviews = useSelector((state: RootState) => state.accommodationReviews);
  const routes = useSelector((state: RootState) => state.routes);
  const dispatch = useDispatch();

  if (accommodationReviews.pagination == null || routes.host?.accommodation == null) {
    return null;
  }

  const { currentPage, totalPages } = accommodationReviews.pagination;
  const nextPage = currentPage < totalPages ? currentPage + 1 : undefined;
  const { loading } = accommodationReviews;

  const { locale } = routes;
  const accommodationId = routes.host.accommodation.id;

  if (!nextPage) {
    return null;
  }

  return (
    <button
      className="load-more-reviews-button"
      onClick={() => dispatch(loadNextPageOfReviews(locale, accommodationId, nextPage))}
      disabled={loading}
      type="button"
    >
      {I18n.t('accommodation_reviews.load_more_reviews')}
    </button>
  );
}

// LoadMoreReviewsButtonComponent.propTypes = {
//   locale: PropTypes.string.isRequired,
//   accommodationId: PropTypes.number.isRequired,
//   nextPage: PropTypes.number,
//   loading: PropTypes.bool.isRequired,
//   loadReviews: PropTypes.func.isRequired,
// };

// function mapStateToProps({ routes, accommodationReviews }) {
//   const currentPage = accommodationReviews.pagination.currentPage;
//   const totalPages = accommodationReviews.pagination.totalPages;

//   const nextPage = currentPage < totalPages ? currentPage + 1 : undefined;

//   return {
//     locale: routes.locale,
//     accommodationId: routes.host.accommodation.id,
//     nextPage,
//     loading: accommodationReviews.loading,
//   };
// }

// const actionCreators = {
//   loadReviews: loadNextPageOfReviews,
// };

// export default connect(mapStateToProps, actionCreators)(LoadMoreReviewsButtonComponent);
